import { fetchApiWithAllFilters } from "@modules/azm/api"
import { breadcrumbRoot } from "@modules/breadcrumb/breadcrumb"
import { afterFilterApiFetched } from "../after-filter-api-fetched"
import { getPage, setPage } from "./pagination"

export async function onPaginationSelectClick(
    event: MouseEvent,
    select: HTMLSelectElement | null,
    scrollToBreadcrumb = false,
) {
    if (!(event.target instanceof HTMLElement)) {
        return
    }

    const value = Number.parseInt(select?.value || "-1")
    if (value === -1) {
        return
    }
    if (getPage() === value) {
        return
    }

    setPage(value)
    await afterFilterApiFetched(await fetchApiWithAllFilters())
    if (scrollToBreadcrumb) {
        breadcrumbRoot()?.scrollIntoView({ behavior: "smooth" })
    }
}
